
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
        if( !this.cart )
        {
            this.cart = document.querySelector('#cart-drawer-wellEasy');
            this.cart.setAttribute( "data-legacy-cart", "true" );
        }

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
        if(this.cart ) 
        {
            if( !this.cart.getAttribute( "data-legacy-cart" ) )
            {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }
            else
            {
                formData.append('sections', "cart-drawer-section");
            }
        }
    
      //Added to generate selling plan add to cart response
      //const sellingPlanId = window.getCurrentSellingPlanId();
      //formData.append("selling_plan", sellingPlanId);
      
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) 
            {
                document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
            }
            else if( this.cart.getAttribute( "data-legacy-cart" ) )
            {
                console.log( "legacy cart !" ) ;
                KlaviyoTrack( "Added to Cart", response );
                updateCartDrawer(response);
                
                if( document.querySelector( "product-info[data-url]" ).dataset.variantUrl )
                {
                  var itemID = document.querySelector( "product-info[data-url]" ).dataset.variantUrl;
                }
                else
                {
                  var itemID = document.querySelector( "product-info[data-url]" ).dataset.url;
                }
                var trackingData =
                {
                    event: "add_to_cart",
                    ecommerce:
                    {
                        currency: "GBP",
                        value: document.querySelector( "product-info[data-url]" ).dataset.variantPrice,
                        items: [
                            { item_id: itemID }
                        ]
                    }
                };

                if (!window.luigiDataLayer) window.luigiDataLayer = [];
                window.luigiDataLayer.push(trackingData);
                
                
                setUpCartEventsWellEasy();
                updateGridSection();
                orderUpdateGridSection();
                wishlistUpdateGridSection();

                // pdp change 24/9/24 : don't pop open the sidecart after adding something
                //var body_element = document.querySelector("body");
                //body_element.classList.add("cart-drawer--show");

                HandleFormButtons( this.form, response, "show" );
            }
            else 
            {
                this.cart.renderContents(response);
            }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}